





































































import mixins from 'vue-typed-mixins'
import FlexibleGallery from '@/builder/sections/section/shared/mixins/FlexibleGallery'
export default mixins(FlexibleGallery).extend({
  name: 'FlexibleCarousel1',
  data () {
    return {
      carousel: 0,
      carouselItems: new Array<Array<string>>()
    }
  },
  watch: {
    items () {
      this.generatePortfolioImages()
    },
    data () {
      this.generatePortfolioImages()
    },
    isMobile () {
      this.generatePortfolioImages()
    }
  },
  computed: {
    getImageWidth (): string {
      const value = ((100 - this.data.configuration.wb_gallery_distance__number__) / this.numberOfPicturesOnScreen)

      return `${value}%`
    },
    getImageStyle (): Record<string, string> {
      return {
        margin: `0 ${this.data.configuration.wb_gallery_distance__number__}px`
      }
    },
    numberOfPicturesOnScreen (): number {
      const configured = this.isMobile
        ? this.data.configuration.wb_gallery_mobile_image_number__number__
        : this.data.configuration.wb_gallery_image_number__number__

      // The builder saves this field on every keystroke, so it can hold 0, an empty value or a
      // fraction; the carousel divides by it.
      return Math.max(1, Math.floor(Number(configured)) || 1)
    }
  },
  mounted () {
    this.generatePortfolioImages()
  },
  methods: {
    generatePortfolioImages (): void {
      const n = this.numberOfPicturesOnScreen
      const items = new Array<string>()

      const images = [...this.data.images]

      images.sort((img1, img2) => {
        const slug1: number = parseInt(img1.slug.replace(/^\D+/g, ''))
        const slug2: number = parseInt(img2.slug.replace(/^\D+/g, ''))
        return slug1 - slug2
      })

      images.forEach((img: any) => {
        items.push(`${this.appConfiguration.imageBaseUrl}${img.name}`)
      })

      this.carouselItems = new Array(Math.ceil(items.length / n))
        .fill('')
        .map(() => items.splice(0, n))
    }
  }
})
